import React from "react";
import LoadingSpinner from "./loadingSpinner";

type ProductLoadingOverlayProps = {
  isUpdating: boolean;
};

const ProductLoadingOverlay: React.FC<ProductLoadingOverlayProps> = ({
  isUpdating,
}) => {
  return (
    <div
      className={`${isUpdating ? "block" : "hidden"} 
        absolute z-[20] flex h-full w-full items-center justify-center bg-light-beige opacity-80`}
    >
      <LoadingSpinner />
    </div>
  );
};

export default ProductLoadingOverlay;
